import { Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

import "../CSS/HomeMobileCard.css"


const HomeMobileCard = ({ id, image, link }) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile


  const buttonStyle = {
    textTransform: "none",
    borderColor: "black",
    backgroundColor: "white",
    borderRadius: "30px",
    fontSize: isMobile ? "12px" : "",
    color: "black",
    px: "20px",
    py: "5px",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
      transition: "0.4s",
    },
  };


  return (
    <div className="base-card">
      <img className="img-phone-card" src={image} alt="Wedding Invitation on Phones" />
      <Typography variant={isMobile ? "h7" : "h6"} >{id}</Typography>
      <div className="button-row">
        <Button variant="outlined" disableElevation sx={buttonStyle} onClick={() => window.open("https://wa.me/60134149684", "_blank")}>
          Order
        </Button>
        <Button variant="outlined" disableElevation sx={buttonStyle} onClick={() => window.open(link, "_blank")}>
          Preview
        </Button>
      </div>
    </div>


  );


};

export default HomeMobileCard;